module.exports = __webpack_public_path__ + "static/img/logo.71f25c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/logo.png
// module id = 3WPC
// module chunks = 1